import React, { Component } from 'react'
import styled from 'styled-components'

const Box = styled.div`
  background: #fff;
  border-radius: 10px;
  border: 1px solid var(--light-gray);
  overflow: hidden;
  width: 100%;
  margin: 1.5rem 0;
  break-inside: avoid;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`

export default class Card extends Component {
  render() {
    return <Box {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Card/Card.js